import styled, { keyframes } from "styled-components";
import colors from "../../styles/colors";

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const pulse = keyframes`
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.6;
  }
`;

export const Container = styled.div<{ $fullScreen?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${props => (props.$fullScreen ? "0" : "20px")};
  min-height: ${props => (props.$fullScreen ? "100vh" : "auto")};
  gap: 16px;
  animation: ${fadeIn} 0.3s ease-out;
`;

export const LoaderWrapper = styled.div`
  animation: ${pulse} 1.5s ease-in-out infinite;
`;

export const Message = styled.p`
  font-family: "Roboto", "Segoe UI", sans-serif;
  font-size: 0.95rem;
  color: ${colors.text.secondary};
  text-align: center;
  margin: 0;
`;
